import { Checkbox, Typography } from 'antd';
import { spacing, textColor } from '../../theming';

const HINT_ID = 'marketing-consent-hint';

// optional and unticked by default; the hint is the checkbox's description for screen readers
const MarketingConsentCheckbox = ({ checked, onChange, disabled = false, t }) => (
    <div style={{ marginTop: spacing[4] }}>
        <Checkbox
            checked={checked}
            disabled={disabled}
            onChange={event => onChange(event.target.checked)}
            aria-describedby={HINT_ID}
        >
            {t('auth:marketing-consent.label')}
        </Checkbox>
        <Typography.Paragraph
            id={HINT_ID}
            style={{ margin: `${spacing[0.5]} 0 0 ${spacing[4]}`, color: textColor.secondary }}
        >
            {t('auth:marketing-consent.hint')}
        </Typography.Paragraph>
    </div>
);

export default MarketingConsentCheckbox;
